import React from 'react';

import { Popconfirm, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandDelete: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        action();
    }

    return (
        <div className={`command ${disabled && 'command-disabled'}`}>
            <Popconfirm
                disabled={disabled}
                title="Are you sure to delete the current order?"
                okText="Yes"
                cancelText="No"
                onConfirm={_handleCommandAction}
            >
                <Tooltip title={'Delete order'}>
                    <DeleteOutlined />
                </Tooltip>
            </Popconfirm>
        </div>
    );
}

export default CommandDelete;